export enum TextType {
  tooltip = 'tooltip',
  label = 'label',
}
